<template>
  <table border="1" cellspacing="0" style="width: 1229px;">
    <tbody>
      <tr style="height: 89.125px;">
        <td bgcolor="#0000C8" style="width: 400px; text-align: center; height: 89.125px;">
          <p class="s8">
            <span style="color: #ffffff;">System Type: Vendor &amp; System Name</span>
          </p>
        </td>
        <td bgcolor="#0000C8" style="width: 10px; text-align: center; height: 89.125px;">
          <p class="s8"><span style="color: #ffffff;">How to Get Support</span></p>
        </td>
        <td
          bgcolor="#0000C8"
          colspan="2"
          style="width: 20px; text-align: center; height: 89.125px;"
        >
          <p class="s8">
            <span style="color: #ffffff;">Support Hours &amp; Languages Supported</span>
          </p>
        </td>
        <td bgcolor="#0000C8" style="width: 416px; text-align: center; height: 89.125px;">
          <p class="s8"><span style="color: #ffffff;">Built-In Application Help</span></p>
        </td>
      </tr>
      <tr style="height: 46px;">
        <td rowspan="2" style="width: 400px; height: 311px;">
          <p class="s9">
            <a name="bookmark1"></a>Access Request for Pfizer Applications (link to online form
            available in Shared Investigator Platform)
          </p>
        </td>
        <td rowspan="2" style="width: 10px; height: 311px;">
          <p class="s10">Pfizer Account Provisioning at</p>
          <p class="s10">
            +1-877-433-2619&nbsp;<a
              class="s21"
              href="http://www.business.att.com/bt/dial_guide.jsp"
              rel="noopener"
              target="_blank"
              >in the US and Canada, Use applicable country codes for international numbers</a
            >
          </p>
          <p class="s10">OPTION 8.3</p>
          <p class="s11">For sites in South Africa, call 0-800- 983-953.</p>
          <p class="s11">For sites with no AT&amp;T code, please email:</p>
          <p class="s14">Email:</p>
          <p class="s32">PfizerAccountProvisioning@c3iservice.com</p>
        </td>
        <td bgcolor="#D9D9D9" colspan="2" style="width: 20px; height: 46px;">
          <p class="s10">English &ndash; 24/7</p>
        </td>
        <td rowspan="2" style="width: 416px; height: 311px;">
          <p class="s11">Email available or add question to comments box</p>
        </td>
      </tr>
      <tr style="height: 265px;">
        <td style="width: 10px; height: 265px;">
          <p class="s11">Spanish German French Italian Russian</p>
        </td>
        <td style="width: 10px; height: 265px;">
          <p class="s11">9:00 AM&ndash;10:00 PM GMT+1, M-F</p>
          <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
          <p class="s11">9:00 AM&ndash;10:00 PM GMT+1, M-F</p>
          <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
          <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
        </td>
      </tr>
      <tr style="height: 163px;">
        <td style="width: 400px; height: 163px;">
          <p class="s9">
            <a name="bookmark2"></a>Central Labs: Covance - Xcellerate Lab Investigator Portal
          </p>
        </td>
        <td style="width: 10px; height: 163px;">
          <p class="s10">Login and Password Support:</p>
          <p>
            <a
              class="s17"
              href="https://register.covance.com/web/ups/passwordmanager"
              rel="noopener"
              target="_blank"
              ><span style="color: #000000;"
                ><span style="color: #000000;"
                  ><span style="color: #000000;"
                    ><span style="color: #000000;"
                      ><span style="color: #000000;"
                        ><span style="color: #000000;"
                          ><span style="color: #000000;"
                            ><span style="color: #000000;"
                              ><span style="color: #000000;"
                                ><span style="color: #000000;"
                                  ><span style="color: #000000;"
                                    ><span style="color: #000000;"
                                      ><span style="color: #000000;"
                                        ><span style="color: #000000;">Password Manager</span></span
                                      ></span
                                    ></span
                                  ></span
                                ></span
                              ></span
                            ></span
                          ></span
                        ></span
                      ></span
                    ></span
                  ></span
                ></span
              ></a
            >
          </p>
          <p>
            <span style="color: #000000;"
              ><a
                href="https://invp.covance.com/ContactUs/contact-us.pdf"
                rel="noopener"
                target="_blank"
                >Investigator Support:&nbsp;</a
              ><a
                class="s17"
                href="https://invp.covance.com/ContactUs/contact-us.pdf"
                rel="noopener"
                target="_blank"
                >Contact Us</a
              ></span
            >
          </p>
        </td>
        <td colspan="2" style="width: 20px; height: 163px;">
          <p class="s10">English &ndash; 24/7</p>
          <p class="s11">Monday to Saturday: Normal business hours based on country location</p>
        </td>
        <td style="width: 416px; height: 163px;">
          General and Application Training Materials available upon login within the dashboard which
          includes: Navigation Training, Quick Reference Guides, Frequently Asked Questions, On
          Screen Results Training, Recorded Demonstration and Navigation Help
        </td>
      </tr>
      <tr style="height: 110px;">
        <td style="width: 400px; height: 110px;">
          <p class="s9"><a name="bookmark3"></a>eConsent: IQVIA &ndash; SecureConsent</p>
        </td>
        <td style="width: 10px; height: 110px;">
          <p class="s10">United States: +1-866-505-6600</p>
          <p class="s11">Outside US: 0120360500 (select language)</p>
          <p>
            <span style="color: #000000;"
              ><a class="s25" href="mailto:Support@secureconsent.com" rel="noopener" target="_blank"
                >Email:&nbsp;</a
              ><a class="s18" href="mailto:Support@secureconsent.com" rel="noopener" target="_blank"
                >Support@secureconsent.com</a
              ></span
            >
          </p>
        </td>
        <td colspan="2" style="width: 20px; height: 110px;">
          <p class="s11">
            24/7 Phone lines open during normal business hours for each locality; currently 50+
            languages supported
          </p>
        </td>
        <td style="width: 416px; height: 110px;">
          <p class="s11">Links to System Topics&nbsp;</p>
        </td>
      </tr>
      <tr style="height: 543px;">
        <td style="width: 400px; height: 543px;">
          <p class="s9"><a name="bookmark4"></a>EDC: DataLabs</p>
        </td>
        <td style="width: 10px; height: 543px;">
          &nbsp;
          <p>For Account Related inquiries:</p>
          <p class="s10">
            +1-877-433-2619&nbsp;<a
              class="s21"
              href="http://www.business.att.com/bt/dial_guide.jsp"
              rel="noopener"
              target="_blank"
              >in the US and Canada, Use applicable country codes for international numbers</a
            >
          </p>
          <p class="s10">OPTION 2</p>
          <p class="s11">For sites in South Africa, call 0-800- 983-953.</p>
          <p>
            <span style="color: #000000;"
              ><a
                class="s25"
                href="mailto:Pfizeredcsupport@@c3iservice.com"
                rel="noopener"
                target="_blank"
                >Email:&nbsp;</a
              ><a
                class="s15"
                href="mailto:Pfizeredcsupport@@c3iservice.com"
                rel="noopener"
                target="_blank"
                >Pfizeredcsupport@c3iservice.com</a
              ></span
            >
          </p>
          <p class="s32">
            <span style="color: #000000;"
              >For Technical Support, access the PAREXEL Customer Service Portal via MyTrials. If
              urgent, call PAREXEL Service Desk (PAREXEL Informatics) using numbers found&nbsp;<a
                href="https://parexel.service-now.com/csm?id=csm_contact_us"
                >here</a
              >&nbsp;<span class="s14">.</span></span
            >
          </p>
        </td>
        <td colspan="2" style="width: 20px; height: 543px;">
          <p>Pfizer Help Desk</p>
          <p>English &ndash; 24/7</p>
          <p>&nbsp;</p>
          <table border="1" cellspacing="0" style="width: 353.047px; border-color: #F4F4F4;">
            <tbody>
              <tr>
                <td style="width: 67px;">
                  <p class="s11">Spanish German French Italian Russian Japanese</p>
                </td>
                <td style="width: 273.047px;">
                  <p class="s11">9:00 AM&ndash;10:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;10:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">8:00 AM&ndash;7:00 PM GMT+9, M-F</p>
                </td>
              </tr>
              <tr>
                <td colspan="2" style="width: 340.047px;">
                  <p class="s10">PAREXEL Informatics/Service Desk</p>
                  <p class="s11">
                    English, Chinese and Japanese (Chinese, Japanese only during local working hours
                    and Third-party Translation Service for outside of those hours). Third party
                    Translation Service for all other languages is available 24/7.
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <p>&nbsp;</p>
          &nbsp;
        </td>
        <td style="width: 416px; height: 543px;">&nbsp;</td>
      </tr>
      <tr style="height: 146px;">
        <td style="width: 400px; height: 146px;">
          <p><a name="bookmark5"></a>EDC: Oracle - Clinical (ICON)</p>
          <p>&nbsp;</p>
        </td>
        <td style="width: 10px; height: 146px;">
          <p class="s10">ICON HelpDesk at +1-888-426-8801</p>
          <p>
            <span style="color: #000000;"
              >or for country-specific numbers, visit:&nbsp;<a
                href="https://icophone.iconplc.com/contact_hd_flex.asp"
                >https://icophone.iconplc.com/contact_hd_flex.asp</a
              ></span
            >
          </p>
          <p>
            <span style="color: #000000;"
              >Email&nbsp;<a
                class="s19"
                href="mailto:icophone@iconplc.com"
                rel="noopener"
                target="_blank"
                >icophone@iconplc.com</a
              ></span
            >
          </p>
          &nbsp;
        </td>
        <td colspan="2" style="width: 20px; height: 146px;">
          &nbsp;
          <table cellspacing="0">
            <tbody>
              <tr>
                <td colspan="2">
                  <p class="s11">
                    24/7/365: All languages supported through a Translation Service, if needed
                  </p>
                </td>
                <td>&nbsp;</td>
              </tr>
            </tbody>
          </table>
        </td>
        <td style="width: 416px; height: 146px;">
          &nbsp;
          <table cellspacing="0">
            <tbody>
              <tr>
                <td>
                  <p class="s11">Help &amp; Contact Us available in system</p>
                </td>
              </tr>
              <tr>
                <td rowspan="2">&nbsp;</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr style="height: 259px;">
        <td style="width: 400px; height: 259px;">
          &nbsp;<a name="bookmark6"></a>EDC: Oracle - InForm
        </td>
        <td style="width: 10px; height: 259px;">
          &nbsp;
          <p>
            <a class="s20" href="#bookmark13"
              ><span style="color: #000000;"
                ><span style="color: #000000;"
                  ><span style="color: #000000;"
                    ><span style="color: #000000;"
                      ><span style="color: #000000;"
                        ><span style="color: #000000;"
                          ><span style="color: #000000;"
                            ><span style="color: #000000;"
                              ><span style="color: #000000;"
                                ><span style="color: #000000;">Exostar Support</span></span
                              ></span
                            ></span
                          ></span
                        ></span
                      ></span
                    ></span
                  ></span
                ></span
              ></a
            >
          </p>
          <p class="s10">Pfizer InForm Support Desk at</p>
          <p class="s10">
            +1-877-433-2619&nbsp;<a
              class="s21"
              href="http://www.business.att.com/bt/dial_guide.jsp"
              rel="noopener"
              target="_blank"
              >in the US and Canada, Use applicable country codes for international numbers</a
            >
          </p>
          <p class="s10">OPTION 2</p>
          <p class="s11">For sites in South Africa, call 0-800- 983-953.</p>
          <p>
            <span style="color: #000000;"
              ><a
                class="s25"
                href="mailto:PfizerInform@c3iservice.com"
                rel="noopener"
                target="_blank"
                >Email:&nbsp;</a
              ><a
                class="s15"
                href="mailto:PfizerInform@c3iservice.com"
                rel="noopener"
                target="_blank"
                >PfizerInform@c3iservice.com</a
              ></span
            >
          </p>
        </td>
        <td colspan="2" style="width: 20px; height: 259px;">
          <p>English &ndash; 24/7&nbsp;</p>
          <table border="1" cellspacing="0" style="width: 353.906px; border-color: #F4F4F4;">
            <tbody>
              <tr>
                <td style="width: 62px;">
                  <p class="s11">Spanish German French Italian Russian Japanese</p>
                </td>
                <td style="width: 279.906px;">
                  <p class="s11">9:00 AM&ndash;10:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;10:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">8:00 AM&ndash;7:00 PM GMT+9, M-F</p>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
        <td style="width: 416px; height: 259px;">
          <p class="s11">Support Contact information on the Study Homepage</p>
          <p class="s11">User Guide available in Help</p>
          &nbsp;
        </td>
      </tr>
      <tr style="height: 305px;">
        <td style="width: 400px; height: 305px;">
          &nbsp;<a name="bookmark7"></a>EDC: Oracle - OC RDC
        </td>
        <td style="width: 10px; height: 305px;">
          <p>&nbsp;Pfizer OC Support Desk at</p>
          <p class="s10">
            +1-877-433-2619&nbsp;<a
              class="s21"
              href="http://www.business.att.com/bt/dial_guide.jsp"
              rel="noopener"
              target="_blank"
              >in the US and Canada, Use applicable country codes for international numbers</a
            >
          </p>
          <p class="s10">OPTION 2</p>
          <p class="s11">For sites in South Africa, call 0-800- 983-953.</p>
          <p>
            <span style="color: #000000;"
              ><a
                class="s25"
                href="mailto:Pfizeredcsupport@@c3iservice.com"
                rel="noopener"
                target="_blank"
                >Email:&nbsp;</a
              ><a
                class="s15"
                href="mailto:Pfizeredcsupport@@c3iservice.com"
                rel="noopener"
                target="_blank"
                >Pfizeredcsupport@@c3iservice.com</a
              ></span
            >
          </p>
          <p>&nbsp;</p>
        </td>
        <td colspan="2" style="width: 20px; height: 305px;">
          <p>English &ndash; 24/7&nbsp;</p>
          <table border="1" cellspacing="0" style="width: 353.344px; border-color: #F4F4F4;">
            <tbody>
              <tr>
                <td style="width: 65px;">
                  <p class="s11">Spanish German French Italian Russian Japanese</p>
                </td>
                <td style="width: 276.344px;">
                  <p class="s11">9:00 AM&ndash;10:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;10:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">8:00 AM&ndash;7:00 PM GMT+9, M-F</p>
                </td>
              </tr>
            </tbody>
          </table>
          <p>&nbsp;</p>
        </td>
        <td style="width: 416px; height: 305px;">
          <table cellspacing="0">
            <tbody>
              <tr>
                <td>
                  <p class="s11">Help &amp; Contact Us Links in Top Navigation</p>
                </td>
              </tr>
              <tr>
                <td>&nbsp;</td>
              </tr>
            </tbody>
          </table>
          &nbsp;
        </td>
      </tr>
      <tr style="height: 132px;">
        <td style="width: 400px; height: 132px;">
          &nbsp;<a name="bookmark8"></a>eiSF: Florence - eBinders and/or Remote Source Access (RSA)
        </td>
        <td style="width: 10px; height: 132px;">
          &nbsp;
          <p class="s10">
            Technical Questions:&nbsp;<a
              class="s21"
              href="mailto:pfizersupport@florencehc.com"
              rel="noopener"
              target="_blank"
              >Email Florence pfizersupport@florencehc.com</a
            >
          </p>
          <p class="s10">
            Process Questions:&nbsp;<span class="s11"
              >Contact your CRA or Study Manager if CRA is not available</span
            >
          </p>
        </td>
        <td colspan="2" style="width: 20px; height: 132px;">&nbsp;</td>
        <td style="width: 416px; height: 132px;">Chat Bot, Knowledge Base, Tips &amp; Tricks</td>
      </tr>
      <tr style="height: 291px;">
        <td style="width: 400px; height: 291px;">
          &nbsp;<a name="bookmark9"></a>Electronic Data Transfer: EDETEK - CONFORM
        </td>
        <td style="width: 10px; height: 291px;">
          &nbsp;
          <p>
            <a class="s20" href="#bookmark13"
              ><span style="color: #000000;"
                ><span style="color: #000000;"
                  ><span style="color: #000000;"
                    ><span style="color: #000000;"
                      ><span style="color: #000000;"
                        ><span style="color: #000000;"
                          ><span style="color: #000000;"
                            ><span style="color: #000000;"
                              ><span style="color: #000000;"
                                ><span style="color: #000000;">Exostar Support</span></span
                              ></span
                            ></span
                          ></span
                        ></span
                      ></span
                    ></span
                  ></span
                ></span
              ></a
            >
          </p>
          <p class="s10">Pfizer CONFORM Support Desk at</p>
          <p class="s10">
            +1-877-433-2619&nbsp;<a
              class="s21"
              href="http://www.business.att.com/bt/dial_guide.jsp"
              rel="noopener"
              target="_blank"
              >in the US and Canada, Use applicable country codes for international numbers</a
            >
          </p>
          <p class="s10">OPTION 8.4</p>
          <p class="s11">For sites in South Africa, call 0-800- 983-953.</p>
          <p>
            <span style="color: #000000;"
              ><a
                class="s21"
                href="mailto:Pfizerconform@c3iservice.com"
                rel="noopener"
                target="_blank"
                >Email:&nbsp;</a
              ><a
                class="s12"
                href="mailto:Pfizerconform@c3iservice.com"
                rel="noopener"
                target="_blank"
                >Pfizerconform@c3iservice.com</a
              ></span
            >
          </p>
        </td>
        <td colspan="2" style="width: 20px; height: 291px;">
          <p>English &ndash; 24/7</p>
          <table border="1" cellspacing="0" style="width: 352.781px; border-color: #F4F4F4;">
            <tbody>
              <tr>
                <td style="width: 61px;">
                  <p class="s11">Spanish German French Italian Russian</p>
                </td>
                <td style="width: 279.781px;">
                  <p class="s11">9:00 AM&ndash;10:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;10:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
                </td>
              </tr>
            </tbody>
          </table>
          <p>&nbsp;</p>
          &nbsp;
        </td>
        <td style="width: 416px; height: 291px;">
          <table cellspacing="0">
            <tbody>
              <tr>
                <td rowspan="2">
                  <p class="s11">N/A</p>
                </td>
              </tr>
              <tr>
                <td>&nbsp;</td>
              </tr>
            </tbody>
          </table>
          &nbsp;
        </td>
      </tr>
      <tr style="height: 146px;">
        <td style="width: 400px; height: 146px;">
          &nbsp;<a name="bookmark10"></a>ePRO: ERT - StudyWorks
        </td>
        <td style="width: 10px; height: 146px;">
          &nbsp;
          <p class="s10">United States&nbsp;: +1-800-704-9698</p>
          <p class="s22">Germany: +49 9305 720 9891</p>
          <p class="s32">
            <a
              href="https://urldefense.proofpoint.com/v2/url?u=https-3A__www.ert.com_contact-2Dcustomer-2Dcare_&amp;d=DwMFaQ&amp;c=UE1eNsedaKncO0Yl_u8bfw&amp;r=WZo5Vg41LQ-bGOzB3HcK46oVZnq6sWf1a-ZSjFLPTJw&amp;m=3_Z5RLvuvOxFkd29iwWQ_s2yGRJB9W9OU2f8hc8hR8E&amp;s=2QouQI6K9O7unHVmliRS7SMv9Y2Obp0II4DDyQUXrjo&amp;e"
              rel="noopener"
              target="_blank"
              ><span style="color: #000000;"
                ><span style="color: #000000;"
                  ><span style="color: #000000;"
                    ><span style="color: #000000;"
                      ><span style="color: #000000;"
                        ><span style="color: #000000;"
                          ><span style="color: #000000;"
                            ><span style="color: #000000;"
                              ><span style="color: #000000;"
                                >Other country numbers found here:
                                https://www.ert.com/contact-customer-care</span
                              ></span
                            ></span
                          ></span
                        ></span
                      ></span
                    ></span
                  ></span
                ></span
              ></a
            >
          </p>
        </td>
        <td colspan="2" style="width: 20px; height: 146px;">
          &nbsp;
          <table cellspacing="0" style="width: 355px;">
            <tbody>
              <tr>
                <td colspan="2" style="width: 360.359px;">
                  <p class="s11">
                    All agents speak English and many speak at least one other major language (e.g.,
                    French, Spanish, Japanese, Chinese, Russian, Polish, Italian, Dutch, German);
                    Over 170 languages via through Translation Service
                  </p>
                </td>
                <td style="width: 10px;">&nbsp;</td>
              </tr>
            </tbody>
          </table>
        </td>
        <td style="width: 416px; height: 146px;">
          <table cellspacing="0">
            <tbody>
              <tr>
                <td>
                  <p class="s11">Support contact information available</p>
                </td>
              </tr>
              <tr>
                <td>&nbsp;</td>
              </tr>
            </tbody>
          </table>
          &nbsp;
        </td>
      </tr>
      <tr style="height: 261px;">
        <td style="width: 400px; height: 261px;">
          &nbsp;<a name="bookmark11"></a>ePRO: Signant Health TrialMax
        </td>
        <td style="width: 10px; height: 261px;">
          &nbsp;
          <p>
            <a class="s20" href="#bookmark13"
              ><span style="color: #000000;"
                ><span style="color: #000000;"
                  ><span style="color: #000000;"
                    ><span style="color: #000000;"
                      ><span style="color: #000000;"
                        ><span style="color: #000000;"
                          ><span style="color: #000000;"
                            ><span style="color: #000000;"
                              ><span style="color: #000000;">Exostar Support</span></span
                            ></span
                          ></span
                        ></span
                      ></span
                    ></span
                  ></span
                ></span
              ></a
            >
          </p>
          <p class="s10">US: +1-866-402-1154</p>
          <p class="s11">For other countries, please use telephone numbers found on this page:</p>
          <p>
            <a
              class="s24"
              href="https://www.signanthealth.com/support/"
              rel="noopener"
              target="_blank"
              ><span style="color: #000000;"
                ><span style="color: #000000;"
                  ><span style="color: #000000;"
                    ><span style="color: #000000;"
                      ><span style="color: #000000;"
                        ><span style="color: #000000;"
                          ><span style="color: #000000;"
                            ><span style="color: #000000;"
                              ><span style="color: #000000;">Support - Signant Health</span></span
                            ></span
                          ></span
                        ></span
                      ></span
                    ></span
                  ></span
                ></span
              ></a
            >
          </p>
          <p class="s11">Each study has unique email contact for helpdesk with the format:</p>
          <p class="s14">STUDYID_TM@support.signanthealth.com</p>
        </td>
        <td colspan="2" style="width: 20px; height: 261px;">
          &nbsp;
          <table cellspacing="0">
            <tbody>
              <tr>
                <td colspan="2">
                  <p class="s11">
                    24/7: 18 directly supported languages including: English, French, Spanish,
                    German, Portuguese, Italian, Dutch, Finnish, Swedish, Romanian, Polish, Czech,
                    Russian, Cantonese, Mandarin, Korean, Hindi and Japanese. Other languages via
                    Translation Service.
                  </p>
                </td>
                <td>&nbsp;</td>
              </tr>
            </tbody>
          </table>
        </td>
        <td style="width: 416px; height: 261px;">
          <table cellspacing="0">
            <tbody>
              <tr>
                <td>
                  <p class="s11">Email link available</p>
                </td>
              </tr>
            </tbody>
          </table>
          <h4>
            <span style="font-weight: 400;">&nbsp;<br /></span>
          </h4>
          &nbsp;
        </td>
      </tr>
      <tr style="height: 128px;">
        <td style="width: 400px; height: 128px;">
          &nbsp;
          <table cellspacing="0">
            <tbody>
              <tr>
                <td>
                  <p class="s9"><a name="bookmark12"></a>ePRO: Yprime - eCOA</p>
                </td>
                <td>&nbsp;</td>
              </tr>
            </tbody>
          </table>
        </td>
        <td style="width: 10px; height: 128px;">
          &nbsp;
          <p class="s10">United States: +1-844-385-2352</p>
          <p class="s11">International Phone Numbers:</p>
          <p class="s32">https://www.yprime.com/support/&nbsp;<span class="s16">.</span></p>
        </td>
        <td colspan="2" style="width: 20px; height: 128px;">
          &nbsp;24/7 Primary English with translators for other languages, protocol specific
        </td>
        <td style="width: 416px; height: 128px;">&nbsp;</td>
      </tr>
      <tr style="height: 128px;">
        <td style="width: 400px; height: 128px;">
          &nbsp;<a name="bookmark12"></a>ePRO: Yprime - eCOA
        </td>
        <td style="width: 10px; height: 128px;">
          &nbsp;
          <p class="s10">United States: +1-844-385-2352</p>
          <p class="s11">International Phone Numbers:</p>
          <p class="s32">https://www.yprime.com/support/&nbsp;<span class="s16">.</span></p>
        </td>
        <td colspan="2" style="width: 20px; height: 128px;">
          &nbsp;
          <table cellspacing="0">
            <tbody>
              <tr>
                <td colspan="2">
                  <p class="s11">
                    24/7 Primary English with translators for other languages, protocol specific
                  </p>
                </td>
                <td>&nbsp;</td>
              </tr>
            </tbody>
          </table>
        </td>
        <td style="width: 416px; height: 128px;">&nbsp;</td>
      </tr>
      <tr style="height: 306px;">
        <td style="width: 400px; height: 306px;">
          <a name="bookmark13"></a>Exostar (Single Sign On)
        </td>
        <td style="width: 10px; height: 306px;">
          &nbsp;
          <p class="s10">
            Exostar Self-Service:&nbsp;<a
              href="https://secureaccess.exostar.com/"
              rel="noopener"
              target="_blank"
              >Please visit&nbsp;</a
            ><a class="s27" href="https://secureaccess.exostar.com/" rel="noopener" target="_blank"
              >https://secureaccess.exostar.com</a
            >&nbsp;<span class="s26"
              >and once logged in navigate to MY ACCOUNT and select one of the options on the
              left.</span
            >
          </p>
          <p class="s29">
            For additional support (multiple Exostar accounts, cannot change security questions,
            need another activation link):
          </p>
          <p class="s30">
            <span style="color: #000000;"
              ><a class="s21" href="#bookmark25">If you have a&nbsp;</a>Shared Investigator&nbsp;<a
                class="s20"
                href="#bookmark25"
                >Platform (SIP)</a
              >&nbsp;<span class="s11"
                >account, please reach out to SIP Support for any Exostar issues.</span
              ></span
            >
          </p>
          <p>
            <span style="color: #000000;"
              ><a
                class="s21"
                href="mailto:CustomerSupport@exostar.com"
                rel="noopener"
                target="_blank"
                >If you do not have a SIP account, reach out to Exostar directly at&nbsp;</a
              ><a
                class="s20"
                href="mailto:CustomerSupport@exostar.com"
                rel="noopener"
                target="_blank"
                >CustomerSupport@exostar.com</a
              ></span
            >
          </p>
        </td>
        <td colspan="2" style="width: 20px; height: 306px;">
          <p class="s10">
            SIP:&nbsp;<span class="s11"
              >English, German, Spanish, French, Swedish, Italian, Portuguese, Japanese, Mandarin
              Chinese</span
            >
          </p>
          <p class="s11">Hours of Support by language available</p>
          <p class="s32">
            <a
              href="https://www.sharedinvestigator.com/sipwsstatic/documents/SIP_Global_Help_Desk_Numbers.html"
              rel="noopener"
              target="_blank"
              ><span style="color: #000000;"
                ><span style="color: #000000;"
                  ><span style="color: #000000;"
                    ><span style="color: #000000;"
                      ><span style="color: #000000;"
                        ><span style="color: #000000;"
                          ><span style="color: #000000;"
                            ><span style="color: #000000;">here</span></span
                          ></span
                        ></span
                      ></span
                    ></span
                  ></span
                ></span
              ></a
            >
          </p>
          <p class="s32">&nbsp;</p>
        </td>
        <td style="width: 416px; height: 306px;">&nbsp;</td>
      </tr>
      <tr style="height: 243px;">
        <td style="width: 400px; height: 243px;">
          &nbsp;<a name="bookmark14"></a>Investigator Payments: Greenphire - eClinicalGPS
        </td>
        <td style="width: 10px; height: 243px;">
          <p>
            <a class="s20" href="#bookmark13"
              ><span style="color: #000000;"
                ><span style="color: #000000;"
                  ><span style="color: #000000;"
                    ><span style="color: #000000;"
                      ><span style="color: #000000;"
                        ><span style="color: #000000;"
                          ><span style="color: #000000;"
                            ><span style="color: #000000;"
                              ><span style="color: #000000;">Exostar Support</span></span
                            ></span
                          ></span
                        ></span
                      ></span
                    ></span
                  ></span
                ></span
              ></a
            >
          </p>
          <p class="s10">United States / Canada:</p>
          <p class="s10">+1-215-609-4378</p>
          <p class="s10">United Kingdom: 0208 150 6470</p>
          <p class="s10">International: (+44) 208 150 6470</p>
          <p class="s16">
            <span style="color: #000000;"
              ><a
                class="s15"
                href="mailto:eclinicalgps@greenphire.com"
                rel="noopener"
                target="_blank"
                >eclinicalgps@greenphire.com</a
              >&nbsp;<span class="s11">or via form in Support Tab in eClinicalGPS</span></span
            >
          </p>
          &nbsp;
        </td>
        <td colspan="2" style="width: 20px; height: 243px;">
          <p class="s10">Hours of Coverage:</p>
          <p class="s11">4:00 AM&ndash;1:00 AM M-F ET</p>
          <p class="s11">8:00 AM&ndash;5:00 AM GMT</p>
          <p class="s11">8:00 AM&ndash;8:00 PM ET, Saturday</p>
          <p class="s11">4:00 AM&ndash;4:00 PM GMT</p>
          <p class="s11">
            Multiple languages available leveraging translator services, as needed
          </p>
          &nbsp;
        </td>
        <td style="width: 416px; height: 243px;">
          Under Support, Reference Documents (Quick Reference Guide, Video, Support Contacts)&nbsp;
        </td>
      </tr>
      <tr style="height: 504px;">
        <td style="width: 400px; height: 504px;">
          &nbsp;
          <table cellspacing="0">
            <tbody>
              <tr>
                <td rowspan="2">
                  <p class="s9"><a name="bookmark16"></a>IRT: IMPALA</p>
                </td>
                <td rowspan="2">&nbsp;</td>
              </tr>
            </tbody>
          </table>
        </td>
        <td style="width: 10px; height: 504px;">
          <p class="s10">Pfizer Impala Support Desk at</p>
          <p class="s10">
            +1-877-433-2619&nbsp;<a
              class="s21"
              href="http://www.business.att.com/bt/dial_guide.jsp"
              rel="noopener"
              target="_blank"
              >in the US and Canada, Use applicable country codes for international numbers</a
            >
          </p>
          <p class="s10">OPTION 3.1</p>
          <p class="s11">Password Resets</p>
          <p class="s11">Self-Service Password Reset option available at the Impala login page</p>
          <p>
            <a>Email:&nbsp;</a
            ><a
              class="s19"
              href="mailto:impalauseradminsupport@c3iservice.com"
              rel="noopener"
              target="_blank"
              >impalauseradminsupport@c3iservice.com</a
            >
          </p>
          <p class="s10">OPTION 3.2</p>
          <p class="s11">For sites in South Africa, call 0-800- 983-953.</p>
          <p>&nbsp;</p>
          <p>
            <span style="color: #000000;"
              ><a class="s21" href="mailto:impala@pfizer.com" rel="noopener" target="_blank"
                >For All Other Impala Technical Issues Email:&nbsp;</a
              ><a class="s33" href="mailto:impala@pfizer.com" rel="noopener" target="_blank"
                >impala@pfizer.com</a
              ></span
            >
          </p>
          &nbsp;
        </td>
        <td colspan="2" style="width: 20px; height: 504px;">
          <p>English &ndash; 24/7</p>
          <table border="1" cellspacing="0" style="width: 354px; border-color: #F4F4F4;">
            <tbody>
              <tr>
                <td style="width: 69.0156px;">
                  <p class="s11">Spanish German</p>
                </td>
                <td style="width: 274.984px;">
                  <p class="s11">9:00 AM&ndash;10:00 PM GMT+1, M-F</p>
                </td>
              </tr>
            </tbody>
          </table>
          <p>&nbsp;</p>
          <table border="1" cellspacing="0" style="width: 354.859px; border-color: #F4F4F4;">
            <tbody>
              <tr>
                <td style="width: 70px;">
                  <p class="s11">French Italian Russian Japanese</p>
                </td>
                <td style="width: 273.859px;">
                  <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;10:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">8:00 AM&ndash;7:00 PM GMT+9, M-F</p>
                </td>
              </tr>
            </tbody>
          </table>
          <p>&nbsp;</p>
          <p class="s11">All other languages via translation service Pfizer.</p>
          <p class="s10">Help Desk Option 3.2</p>
          <p class="s11">24/7 English Only</p>
          &nbsp;
        </td>
        <td style="width: 416px; height: 504px;">
          &nbsp;
          <ul id="l2">
            <li data-list-text="&bull;">
              <p class="s11">Receipt of investigational product guide</p>
            </li>
            <li data-list-text="&bull;">
              <p class="s11">Self-service password reset guide</p>
            </li>
            <li data-list-text="&bull;">
              <p class="s11">Impala data change request form</p>
            </li>
          </ul>
          <p class="s11">
            These documents are available in the Help Documents link located above the Main Menu.
          </p>
        </td>
      </tr>
      <tr style="height: 390px;">
        <td style="width: 400px; height: 390px;">&nbsp;<a name="bookmark17"></a>IRT: IMPALA 2.0</td>
        <td style="width: 10px; height: 390px;">
          &nbsp;
          <p>
            <a class="s20" href="#bookmark13"
              ><span style="color: #000000;"
                ><span style="color: #000000;"
                  ><span style="color: #000000;"
                    ><span style="color: #000000;"
                      ><span style="color: #000000;"
                        ><span style="color: #000000;"
                          ><span style="color: #000000;"
                            ><span style="color: #000000;">Exostar Support</span></span
                          ></span
                        ></span
                      ></span
                    ></span
                  ></span
                ></span
              ></a
            >
          </p>
          <p class="s10">Pfizer Impala Support Desk at</p>
          <p class="s10">
            +1-877-433-2619<a
              class="s21"
              href="http://www.business.att.com/bt/dial_guide.jsp"
              rel="noopener"
              target="_blank"
              ><br />in the US and Canada, Use applicable country codes for international numbers</a
            >
          </p>
          <p class="s10">OPTION 8.3</p>
          <p class="s11">For sites in South Africa, call 0-800- 983-953.</p>
          <p class="s11">For User Access Management Email:</p>
          <p>
            <a
              class="s34"
              href="mailto:impalauseradminsupport@c3iservice.com"
              rel="noopener"
              target="_blank"
              ><span style="color: #000000;"
                ><span style="color: #000000;"
                  ><span style="color: #000000;"
                    ><span style="color: #000000;"
                      ><span style="color: #000000;"
                        ><span style="color: #000000;"
                          ><span style="color: #000000;"
                            ><span style="color: #000000;"
                              >impalauseradminsupport@c3iservice.com</span
                            ></span
                          ></span
                        ></span
                      ></span
                    ></span
                  ></span
                ></span
              ></a
            >
          </p>
          <p class="s10">OPTION 3.2</p>
          <p class="s11">For All Other Impala Technical Issues</p>
          <p>
            <span style="color: #000000;"
              ><a class="s25" href="mailto:impala@pfizer.com" rel="noopener" target="_blank"
                >Email:&nbsp;</a
              ><a class="s34" href="mailto:impala@pfizer.com" rel="noopener" target="_blank"
                >impala@pfizer.com</a
              ></span
            >
          </p>
        </td>
        <td colspan="2" style="width: 20px; height: 390px;">
          <p>English &ndash; 24/7</p>
          <p>&nbsp;</p>
          <table border="1" cellspacing="0" style="width: 354px; border-color: #F4F4F4;">
            <tbody>
              <tr>
                <td style="width: 71.3906px;">
                  <p class="s11">Spanish German French Italian Russian Japanese</p>
                </td>
                <td style="width: 271.609px;">
                  <p class="s11">9:00 AM&ndash;10:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;10:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">8:00 AM&ndash;7:00 PM GMT+9, M-F</p>
                </td>
              </tr>
            </tbody>
          </table>
          &nbsp;
          <p class="s11">All other languages via translation service Pfizer.</p>
          <p class="s10">Help Desk Option 3.2</p>
        </td>
        <td style="width: 416px; height: 390px;">
          &nbsp;
          <p class="s11">Help documents are available within the Impala 2.0 System:</p>
          <ul id="l3">
            <li data-list-text="&bull;">
              <p class="s11">Study specific guide</p>
            </li>
            <li data-list-text="&bull;">
              <p class="s11">Receipt of investigational product guide</p>
            </li>
            <li data-list-text="&bull;">
              <p class="s11">Impala data change request form</p>
            </li>
          </ul>
          <p class="s11">
            These documents are available in the Study Help link located in the top righthand corner
            of the Impala 2.0 System.
          </p>
        </td>
      </tr>
      <tr style="height: 92px;">
        <td style="width: 400px; height: 92px;">
          &nbsp;<a name="bookmark18"></a>IRT: Almac - IXRS&nbsp;<span class="s36">&reg;</span>3
        </td>
        <td style="width: 10px; height: 92px;">
          &nbsp;<a class="s20" href="mailto:IRTHelp@almacgroup.com" rel="noopener" target="_blank"
            >RTHelp@almacgroup.com</a
          >&nbsp;or 1-877-738-8831 (press 00) USA
        </td>
        <td colspan="2" style="width: 20px; height: 92px;">
          &nbsp;
          <table cellspacing="0">
            <tbody>
              <tr>
                <td colspan="2">
                  <p class="s11">24x7x365 with language support</p>
                </td>
                <td>&nbsp;</td>
              </tr>
            </tbody>
          </table>
        </td>
        <td style="width: 416px; height: 92px;">
          <table cellspacing="0">
            <tbody>
              <tr>
                <td>
                  <p class="s11">Online help</p>
                </td>
              </tr>
              <tr>
                <td>&nbsp;</td>
              </tr>
            </tbody>
          </table>
          &nbsp;
        </td>
      </tr>
      <tr style="height: 243px;">
        <td style="width: 400px; height: 243px;">
          <a name="bookmark19"></a>Patient Payments: Greenphire - ClinCard
        </td>
        <td style="width: 10px; height: 243px;">
          &nbsp;
          <p>
            <a class="s20" href="#bookmark13"
              ><span style="color: #000000;"
                ><span style="color: #000000;"
                  ><span style="color: #000000;"
                    ><span style="color: #000000;"
                      ><span style="color: #000000;"
                        ><span style="color: #000000;"
                          ><span style="color: #000000;">Exostar Support</span></span
                        ></span
                      ></span
                    ></span
                  ></span
                ></span
              ></a
            >
          </p>
          <p class="s10">United States / Canada:</p>
          <p class="s10">+1-215-609-4378</p>
          <p class="s10">United Kingdom: 0208 150 6470</p>
          <p class="s10">International: (+44) 208 150 6470</p>
          <p>
            <a class="s15" href="mailto:support@greenphire.com"
              ><span style="color: #000000;"
                ><span style="color: #000000;"
                  ><span style="color: #000000;"
                    ><span style="color: #000000;"
                      ><span style="color: #000000;"
                        ><span style="color: #000000;"
                          ><span style="color: #000000;">support@greenphire.com</span></span
                        ></span
                      ></span
                    ></span
                  ></span
                ></span
              ></a
            >
          </p>
        </td>
        <td colspan="2" style="width: 20px; height: 243px;">
          &nbsp;
          <p class="s10">Hours of Coverage:</p>
          <p class="s11">4:00 AM&ndash;1:00 AM M-F ET</p>
          <p class="s11">8:00 AM&ndash;5:00 AM GMT</p>
          <p class="s11">8:00 AM&ndash;8:00 PM ET, Saturday</p>
          <p class="s11">4:00 AM&ndash;4:00 PM GMT</p>
          <p class="s11">
            Multiple languages available leveraging translator services, as needed
          </p>
        </td>
        <td style="width: 416px; height: 243px;">
          <table cellspacing="0">
            <tbody>
              <tr>
                <td>
                  <p class="s11">Under Support, Reference Documents</p>
                </td>
              </tr>
              <tr>
                <td rowspan="2">&nbsp;</td>
              </tr>
            </tbody>
          </table>
          &nbsp;
        </td>
      </tr>
      <tr style="height: 291px;">
        <td style="width: 400px; height: 291px;">
          &nbsp;<a name="bookmark20"></a>Prescreening: WCG - iConnect
        </td>
        <td style="width: 10px; height: 291px;">
          &nbsp;
          <p>
            <a class="s20" href="#bookmark13"
              ><span style="color: #000000;"
                ><span style="color: #000000;"
                  ><span style="color: #000000;"
                    ><span style="color: #000000;"
                      ><span style="color: #000000;"
                        ><span style="color: #000000;"
                          ><span style="color: #000000;">Exostar Support</span></span
                        ></span
                      ></span
                    ></span
                  ></span
                ></span
              ></a
            >
          </p>
          <p class="s10">Pfizer iConnect Support Desk at</p>
          <p class="s10">
            +1-877-433-2619&nbsp;<a
              class="s21"
              href="http://www.business.att.com/bt/dial_guide.jsp"
              rel="noopener"
              target="_blank"
              >in the US and Canada, Use applicable country codes for international numbers</a
            >
          </p>
          <p class="s10">OPTION 7</p>
          <p class="s11">For sites in South Africa, call 0-800- 983-953.</p>
          <p class="s32">
            <span style="color: #000000;"
              ><a
                class="s25"
                href="mailto:pfizericonnectsupport@c3iservice.com"
                rel="noopener"
                target="_blank"
                >Email:&nbsp;</a
              >pfizericonnectsupport@c3iservice.com</span
            >
          </p>
        </td>
        <td colspan="2" style="width: 20px; height: 291px;">
          <p>&nbsp;</p>
          <p>English &ndash; 24/7</p>
          <table border="1" cellspacing="0" style="width: 355px; border-color: #F4F4F4;">
            <tbody>
              <tr>
                <td style="width: 66.3438px;">
                  <p class="s11">Spanish German French Italian Russian Japanese</p>
                </td>
                <td style="width: 276.656px;">
                  <p class="s11">9:00 AM&ndash;10:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;10:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">8:00 AM&ndash;7:00 PM GMT+9, M-F</p>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
        <td style="width: 416px; height: 291px;">
          <table cellspacing="0">
            <tbody>
              <tr>
                <td rowspan="2">
                  <p class="s11">N/A</p>
                </td>
              </tr>
              <tr>
                <td>&nbsp;</td>
              </tr>
            </tbody>
          </table>
          &nbsp;
        </td>
      </tr>
      <tr style="height: 326px;">
        <td style="width: 400px; height: 326px;">&nbsp;<a name="bookmark21"></a>PSSA Tool</td>
        <td style="width: 10px; height: 326px;">
          &nbsp;
          <p>
            <a class="s20" href="#bookmark13"
              ><span style="color: #000000;"
                ><span style="color: #000000;"
                  ><span style="color: #000000;"
                    ><span style="color: #000000;"
                      ><span style="color: #000000;"
                        ><span style="color: #000000;">Exostar Support</span></span
                      ></span
                    ></span
                  ></span
                ></span
              ></a
            >
          </p>
          <p class="s11">
            Technical support or to request an Exostar ID for PSSA access (for sites unable to
            register in SIP)
          </p>
          <p class="s10">Support Desk at</p>
          <p class="s10">
            +1-877-433-2619&nbsp;<a
              class="s21"
              href="http://www.business.att.com/bt/dial_guide.jsp"
              rel="noopener"
              target="_blank"
              >in the US and Canada, Use applicable country codes for international numbers</a
            >
          </p>
          <p class="s11">OPTION 6</p>
          <p class="s11">For sites in South Africa, call 0-800- 983-953.</p>
          <p class="s10">Email:</p>
          <p>
            <a class="s12" href="mailto:PfizerPSSA@c3iservice.com"
              ><span style="color: #000000;"
                ><span style="color: #000000;"
                  ><span style="color: #000000;"
                    ><span style="color: #000000;"
                      ><span style="color: #000000;"
                        ><span style="color: #000000;">PfizerPSSA@c3iservice.com</span></span
                      ></span
                    ></span
                  ></span
                ></span
              ></a
            >
          </p>
        </td>
        <td colspan="2" style="width: 20px; height: 326px;">
          <p>English &ndash; 24/7</p>
          <p>&nbsp;</p>
          <table border="1" cellspacing="0" style="width: 354px; border-color: #F4F4F4;">
            <tbody>
              <tr>
                <td style="width: 58.875px;">
                  <p class="s11">Spanish German French Italian Russian</p>
                </td>
                <td style="width: 284.125px;">
                  <p class="s11">9:00AM&ndash;10:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00AM&ndash;10:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">Communication via email is in English only</p>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
        <td style="width: 416px; height: 326px;">
          <p class="s11">Help documents are available within the Firecrest System:</p>
          <ul id="l4">
            <li data-list-text="&bull;">
              <p class="s11">Basic Functionality</p>
            </li>
            <li data-list-text="&bull;">
              <p class="s11">PSSA Completion Guide</p>
            </li>
          </ul>
          &nbsp;
        </td>
      </tr>
      <tr style="height: 323px;">
        <td style="width: 400px; height: 323px;">
          &nbsp;<a name="bookmark22"></a>Safety Reporting: SIRIUS
        </td>
        <td style="width: 10px; height: 323px;">
          &nbsp;
          <p>
            <a class="s20" href="#bookmark13"
              ><span style="color: #000000;"
                ><span style="color: #000000;"
                  ><span style="color: #000000;"
                    ><span style="color: #000000;"
                      ><span style="color: #000000;">Exostar Support</span></span
                    ></span
                  ></span
                ></span
              ></a
            >
          </p>
          <p class="s10">Pfizer SIRIUS Support Desk at</p>
          <p class="s10">
            +1-877-433-2619&nbsp;<a
              class="s21"
              href="http://www.business.att.com/bt/dial_guide.jsp"
              rel="noopener"
              target="_blank"
              >in the US and Canada, Use applicable country codes for international numbers</a
            >
          </p>
          <p class="s10">OPTION 4</p>
          <p class="s11">For sites in South Africa, call 0-800- 983-953.</p>
          <p class="s11">For sites with no AT&amp;T code, email:</p>
          <p>
            <span style="color: #000000;"
              ><a
                class="s25"
                href="mailto:PfizerSirius@c3iservice.com"
                rel="noopener"
                target="_blank"
                >Email:&nbsp;</a
              ><a
                class="s15"
                href="mailto:PfizerSirius@c3iservice.com"
                rel="noopener"
                target="_blank"
                >PfizerSirius@c3iservice.com</a
              ></span
            >
          </p>
        </td>
        <td colspan="2" style="width: 20px; height: 323px;">
          <p>English &ndash; 24/7</p>
          <table border="1" cellspacing="0" style="width: 354px; border-color: #F4F4F4;">
            <tbody>
              <tr>
                <td style="width: 58.3906px;">
                  <p class="s11">Spanish German French Italian Russian Japanese</p>
                </td>
                <td style="width: 284.609px;">
                  <p class="s11">9:00 AM&ndash;10:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;10:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">9:00 AM&ndash;5:00 PM GMT+1, M-F</p>
                  <p class="s11">8:00 AM&ndash;7:00 PM GMT+9, M-F</p>
                </td>
              </tr>
            </tbody>
          </table>
          <p>&nbsp;</p>
          &nbsp;
        </td>
        <td style="width: 416px; height: 323px;">
          <table cellspacing="0">
            <tbody>
              <tr>
                <td rowspan="2">
                  <p class="s11">N/A</p>
                </td>
              </tr>
              <tr>
                <td>&nbsp;</td>
              </tr>
            </tbody>
          </table>
          &nbsp;
        </td>
      </tr>
      <tr style="height: 128px;">
        <td style="width: 400px; height: 128px;">
          &nbsp;<a name="bookmark23"></a>Site Activation: Oracle - Activate
        </td>
        <td style="width: 10px; height: 128px;">
          <p>
            <a class="s20" href="#bookmark13"
              ><span style="color: #000000;"
                ><span style="color: #000000;"
                  ><span style="color: #000000;"
                    ><span style="color: #000000;">Exostar Support</span></span
                  ></span
                ></span
              ></a
            >
          </p>
          <p class="s11">Contact your Pfizer / CRO Activate Point of Contact for the study</p>
          &nbsp;
        </td>
        <td colspan="2" style="width: 20px; height: 128px;">
          <p>&nbsp;</p>
          <p>N/A</p>
          <p>&nbsp;</p>
          &nbsp;
        </td>
        <td style="width: 416px; height: 128px;">
          <p>N/A</p>
          <p>&nbsp;</p>
        </td>
      </tr>
      <tr style="height: 96px;">
        <td style="width: 400px; height: 96px;">
          <a name="bookmark24"></a>Site Feasibility: Site Intelligence &amp; Selection Tool
        </td>
        <td style="width: 10px; height: 96px;">
          &nbsp;Study Specific site contact specialist at Pfizer, embedded in invitation email
        </td>
        <td colspan="2" style="width: 20px; height: 96px;">
          &nbsp;
          <p>N/A</p>
          <p>&nbsp;</p>
        </td>
        <td style="width: 416px; height: 96px;">
          &nbsp;
          <p>N/A</p>
          <p>&nbsp;</p>
        </td>
      </tr>
      <tr style="height: 247px;">
        <td style="width: 400px; height: 247px;">
          &nbsp;<a name="bookmark25"></a>Site Platform: Shared Investigator Platform (SIP)
        </td>
        <td style="width: 10px; height: 247px;">
          &nbsp;
          <p>
            <a
              class="s21"
              href="https://www.sharedinvestigator.com/sipwsstatic/html/job_aids/user_job_aids/pdf/Site_User_Job_Aid_Password_Management.pdf"
              rel="noopener"
              target="_blank"
              >For Password-related inquiries, view this&nbsp;</a
            ><a
              class="s28"
              href="https://www.sharedinvestigator.com/sipwsstatic/html/job_aids/user_job_aids/pdf/Site_User_Job_Aid_Password_Management.pdf"
              rel="noopener"
              target="_blank"
              >job aid</a
            >&nbsp;
          </p>
          <p class="s10">US: +1-855-770-2615</p>
          <p>
            <a
              class="s21"
              href="https://www.sharedinvestigator.com/sipwsstatic/documents/SIP_Global_Help_Desk_Numbers.html"
              rel="noopener"
              target="_blank"
              >International: See&nbsp;</a
            ><a
              class="s27"
              href="https://www.sharedinvestigator.com/sipwsstatic/documents/SIP_Global_Help_Desk_Numbers.html"
              rel="noopener"
              target="_blank"
              >phone numbers</a
            >
          </p>
          <p><a class="s15" href="mailto:SIPhelp@cognizant.com">SIPhelp@cognizant.com</a></p>
          <p class="s14">
            <a class="s25" href="http://www.sharedinvestigator.com/" rel="noopener" target="_blank"
              >For a Shared Investigator Platform (SIP) invitation, please contact your Pfizer point
              of contact or site monitor. Or you may click the &ldquo;Join SIP&rdquo; link at the
              top of the&nbsp;</a
            >www.sharedinvestigator.com webpage.
          </p>
        </td>
        <td colspan="2" style="width: 20px; height: 247px;">
          <p class="s11">
            English, German, Spanish, French, Swedish, Italian, Portuguese, Japanese, Mandarin
            Chinese
          </p>
          <p class="s11">Hours of Support by language available</p>
          <p class="s32">
            <a
              href="https://www.sharedinvestigator.com/sipwsstatic/documents/SIP_Global_Help_Desk_Numbers.html"
              rel="noopener"
              target="_blank"
              >here</a
            >
          </p>
          <p class="s32">&nbsp;</p>
        </td>
        <td style="width: 416px; height: 247px;">
          <ul id="l5">
            <li data-list-text="&bull;">
              <p class="s11">Job Aids are available within the application web help</p>
            </li>
            <li data-list-text="&bull;">
              <p class="s11">Login help is located on the SIP login page</p>
            </li>
            <li data-list-text="&bull;">
              <p class="s11">Contact Us Button on Homepage</p>
            </li>
          </ul>
          &nbsp;
        </td>
      </tr>
      <tr style="height: 143px;">
        <td style="width: 400px; height: 143px;">
          &nbsp;<a name="bookmark26"></a>Training Portal: Firecrest
        </td>
        <td style="width: 10px; height: 143px;">
          &nbsp;
          <p class="s32">
            <a
              href="https://www.iconplc.com/contact/global-office-locator/"
              rel="noopener"
              target="_blank"
              >Phone Numbers:&nbsp;</a
            >https://www.iconplc.com/contact/glob
          </p>
          <p class="s32">
            <a
              href="https://www.iconplc.com/contact/firecrest-customer-support/"
              rel="noopener"
              target="_blank"
              >Support Form&nbsp;</a
            ><a
              class="s15"
              href="https://www.iconplc.com/contact/firecrest-customer-support/"
              rel="noopener"
              target="_blank"
              >https://www.iconplc.com/contact/firecal-office-locator/firecrest-customer-support/</a
            >&nbsp;<a>(response within two days)</a>
          </p>
        </td>
        <td colspan="2" style="width: 20px; height: 143px;">
          &nbsp;
          <table cellspacing="0">
            <tbody>
              <tr>
                <td colspan="2">
                  <p class="s10">English &ndash; 24/7</p>
                </td>
                <td>&nbsp;</td>
              </tr>
            </tbody>
          </table>
        </td>
        <td style="width: 416px; height: 143px;">
          &nbsp;
          <table cellspacing="0">
            <tbody>
              <tr>
                <td>
                  <p class="s11">Support available within Study Portals</p>
                </td>
              </tr>
            </tbody>
          </table>
          <h4>&nbsp;</h4>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
  export default {
    name: 'app-support-applications-table',
  };
</script>
